module.exports = __webpack_public_path__ + "static/media/edit-green.922ce47a.svg";